import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuthToggleContext } from "../../components/providers/AuthProvider.jsx";
import { SlideCard, BrandButton } from "../../components/ui/index.js";
import { CheckCircle, XCircle, Loader } from "lucide-react";

function VerifyEmail() {
    const { handleVerifyEmail } = useAuthToggleContext();
    const [searchParams] = useSearchParams();

    const uid   = searchParams.get('uid') || '';
    const token = searchParams.get('token') || '';

    const [status, setStatus] = useState('loading'); // 'loading' | 'ok' | 'error'
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!uid || !token) {
            setStatus('error');
            setMessage('Enlace inválido o incompleto.');
            return;
        }
        handleVerifyEmail({ uid, token }).then(res => {
            if (res.ok) {
                setStatus('ok');
            } else {
                setStatus('error');
                setMessage(res.message);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const content = (
        <div className="flex flex-col items-center gap-4 text-center">
            {status === 'loading' && (
                <>
                    <Loader size={48} className="text-primary animate-spin" />
                    <p className="text-gray-600 dark:text-gray-300">Verificando tu cuenta&hellip;</p>
                </>
            )}

            {status === 'ok' && (
                <>
                    <CheckCircle size={56} className="text-success" />
                    <h2 className="text-2xl md:text-3xl font-extrabold dark:text-white text-gray-900">
                        ¡Cuenta verificada!
                    </h2>
                    <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
                        Tu email ha sido confirmado. Ya puedes iniciar sesión.
                    </p>
                    <Link to="/login">
                        <BrandButton variant="solid" size="md">Iniciar sesión</BrandButton>
                    </Link>
                </>
            )}

            {status === 'error' && (
                <>
                    <XCircle size={56} className="text-error" />
                    <h2 className="text-2xl md:text-3xl font-extrabold dark:text-white text-gray-900">
                        Verificación fallida
                    </h2>
                    <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">{message}</p>
                    <div className="flex gap-3">
                        <Link to="/login">
                            <BrandButton variant="outline" size="md">Login</BrandButton>
                        </Link>
                        <Link to="/register">
                            <BrandButton variant="solid" size="md">Registrarse</BrandButton>
                        </Link>
                    </div>
                </>
            )}
        </div>
    );

    return (
        <div className="flex flex-col md:flex-row h-full w-full">

            {/* ── MÓVIL: panel arriba + logo del fondo debajo ───────────────── */}
            <div className="md:hidden flex flex-col h-full w-full">
                <div className="flex-shrink-0 dark:bg-base-300/80 bg-white/85 backdrop-blur-md border-b border-white/10 dark:border-white/5 px-6 py-10">
                    {content}
                </div>
                <div className="flex-1" />
            </div>

            {/* ── TABLET / DESKTOP: tarjeta a la derecha, logo a la izquierda ── */}
            <div className="hidden md:flex flex-1 items-center justify-end w-full h-full px-8 lg:px-12">
                <SlideCard
                    direction="right"
                    className="glassCard rounded-2xl shadow-xl w-[50%] lg:w-[40%] max-h-[88vh] overflow-y-auto p-8 flex flex-col justify-center"
                >
                    {content}
                </SlideCard>
            </div>

        </div>
    );
}

export default VerifyEmail;
